(function () {
  'use strict';

  function initFloatingATC() {
    var container = document.getElementById('floating-atc');
    if (!container) return;

    var targetId = container.dataset.observeTarget;
    var originalBtn = document.getElementById(targetId);
    if (!originalBtn) return;

    var floatingBtn = container.querySelector('.floating-atc__btn');

    // Show / hide when original button leaves / enters viewport
    var intersectionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            container.classList.remove('floating-atc--visible');
            container.setAttribute('aria-hidden', 'true');
          } else {
            container.classList.add('floating-atc--visible');
            container.setAttribute('aria-hidden', 'false');
          }
        });
      },
      { threshold: 0 }
    );

    intersectionObserver.observe(originalBtn);

    // Click: smooth scroll to original button
    if (floatingBtn) {
      floatingBtn.addEventListener('click', function () {
        originalBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    // Keep prices in sync with the original button
    function syncContent() {
      var origPrice = originalBtn.querySelector('.product-form__price');
      var origPriceOld = originalBtn.querySelector('.product-form__price-old');
      var floatPrice = floatingBtn && floatingBtn.querySelector('.product-form__price');
      var floatPriceOld = floatingBtn && floatingBtn.querySelector('.product-form__price-old');

      if (origPrice && floatPrice) {
        floatPrice.textContent = origPrice.textContent;
      }
      if (origPriceOld && floatPriceOld) {
        floatPriceOld.textContent = origPriceOld.textContent;
      }

      // Mirror disabled / unavailable state
      var isDisabled =
        originalBtn.disabled ||
        originalBtn.getAttribute('aria-disabled') === 'true';

      if (floatingBtn) {
        if (isDisabled) {
          floatingBtn.setAttribute('disabled', '');
        } else {
          floatingBtn.removeAttribute('disabled');
        }
      }
    }

    var mutationObserver = new MutationObserver(syncContent);
    mutationObserver.observe(originalBtn, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });

    syncContent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatingATC);
  } else {
    initFloatingATC();
  }
})();
